
import seoTags from "@/mixins/seoTags";

export default {
	mixins: [seoTags],
	mounted() {
		setTimeout(function () {window.scrollTo(0, -100);}, 1);
	},
}
